export const isError = (err: unknown): err is Error => err instanceof Error

export const errorMessage = (err: unknown): string => {
  if (isError(err)) {
    return err.message
  }

  return String(err)
}
